import axios, { AxiosRequestConfig } from 'axios';
import { getQriServiceUrl } from '../utils/qriServiceUrl';

export const standardHeaders = {
  'Cache-Control': 'no-store, no-cache, must-revalidate',
  'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
  Pragma: 'no-cache',
};

const api = axios.create({
  headers: standardHeaders,
  baseURL: `${process.env.REACT_APP_API_URL}`,
  withCredentials: true,
});

const applicationJson = 'application/json';

export const globalSearchApi = axios.create({
  headers: {
    'Content-Type': applicationJson,
  },
  baseURL: `${process.env.REACT_APP_GLOBAL_SEARCH_SERVICE_URL}`,
  withCredentials: true,
});

export const medtechApi = axios.create({
  headers: {
    ...standardHeaders,
    Accept: applicationJson,
    'Content-Type': applicationJson,
  },
  baseURL: `${process.env.REACT_APP_MEDTECH_BACKEND_API_URL}`,
  withCredentials: true,
});

export const medtechFileUploadApi = axios.create({
  headers: standardHeaders,
  baseURL: `${process.env.REACT_APP_MEDTECH_BACKEND_API_URL}`,
  withCredentials: true,
});

export const qriApi = axios.create({
  headers: {
    'Content-Type': applicationJson,
  },
  baseURL: getQriServiceUrl(),
  withCredentials: true,
});

qriApi.interceptors.request.use((config) => ({ ...config, baseURL: getQriServiceUrl() }));

export const exportApi = axios.create({
  headers: {
    'Content-Type': applicationJson,
  },
  baseURL: `${process.env.REACT_APP_EXPORT_SERVICE_URL}`,
  withCredentials: true,
});

export const createRequestConfig = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const defaults = {
    paramsSerializer: (params: Record<string, unknown>) => {
      const searchParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        (Array.isArray(value) ? value : [value]).forEach((item) => {
          if (item !== undefined) {
            searchParams.append(key, String(item ?? ''));
          }
        });
      });
      searchParams.sort();
      return searchParams.toString();
    },
  };

  return { ...config, ...defaults };
};

export default api;
